import { create } from "zustand"

export const uiStore = create((set) => ({
  isCollapsed: true,
  isMobileScreen: window.innerWidth < 768,

  setIsCollapsed: (val) => set({ isCollapsed: val }),
  toggleCollapsed: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
  setIsMobileScreen: (val) => set({ isMobileScreen: val }),

  handleResize: () => {
    const isMobile = window.innerWidth < 768
    set((state) => ({
      isMobileScreen: isMobile,
      isCollapsed: isMobile ? true : state.isCollapsed,
    }))
  },
}))
